import { render, staticRenderFns } from "./CertificateDetailsPage.vue?vue&type=template&id=4ca5dfa9&"
import script from "./CertificateDetailsPage.vue?vue&type=script&lang=js&"
export * from "./CertificateDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports